import React from 'react';
import "./c21t_siblings_nav.scss";
import {PageLeftItem} from "../../model/page";
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";


export interface NavLink {
    label: string;
    url: string;
    active?: boolean;
}

export interface C21TSiblingsNavData extends PageLeftItem {
    level2: NavLink;
    level3: NavLink[];
}

class C21TSiblingsNav extends DoubleTemplateComponent<C21TSiblingsNavData> {

    static readonly ID: string = "siblings_navigation";

    componentRender(data: C21TSiblingsNavData): React.ReactElement {

        return (
            <div className="c21t-siblings-nav">
                {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                <a className="arrow d-block d-sm-none d-lg-block" href={data.level2.url} />
                <a className="level2" href={data.level2.url}>
                    {data.level2.label}
                </a>
                <p className="hyphen">-</p>
                {data.level3 && data.level3.map((link: NavLink, index: number) =>
                    <a key={`siblings-nav-${index}`} className={"level3 " + (link.active ? "active" : "")} href={link.url}>{link.label}</a>
                )}
            </div>
        );
    }
}

export default C21TSiblingsNav;